import { cn } from '@/lib/utils'
import {
  CardInfo,
  Section,
  SectionHeader,
  Slide,
  Slider
} from '@/ui/components'
import { memo } from 'react'
import { SectionInfoProps } from './type'

const SectionInfo = ({
  section,
  items,
  sectionHeaderData
}: SectionInfoProps) => (
  <Section data={section} className="s-section-info">
    <SectionHeader {...sectionHeaderData} />
    <Slider
      className="pt-lg"
      showProgressBar={true}
      slidesPerView={4}
      sliderOptions={{
        dragFree: true
      }}
    >
      {items?.map((item, index) => (
        <Slide
          key={index?.toString()}
          className={cn(item.image && 'lg:col-span-2')}
        >
          <CardInfo {...item} />
        </Slide>
      ))}
    </Slider>
  </Section>
)

SectionInfo.displayName = 'SectionInfo'

export default memo(SectionInfo)
